// extracted by mini-css-extract-plugin
export default {"consentContainer":"styles_consentContainer__wXJZT","section":"styles_section__kJz+S","list":"styles_list__6vIFS","Layout":"styles_Layout__-UW5j"};